class Singleton {
  KEY_LOCALSTORAGE_TOKEN = "jamii_token";
  KEY_LOCALSTORAGE_USERDATA = "jamii_user_data";

  constructor() {
    this.token = null;
    this.userData = null;

    if (
      window.localStorage.getItem(this.KEY_LOCALSTORAGE_TOKEN) &&
      window.localStorage.getItem(this.KEY_LOCALSTORAGE_USERDATA)
    ) {
      this.token = window.localStorage.getItem(this.KEY_LOCALSTORAGE_TOKEN);

      let texto = window.localStorage.getItem(this.KEY_LOCALSTORAGE_USERDATA);
      this.userData = JSON.parse(texto);
    }
  }

  registrarLogin(token, isSaveLocalStorage = false) {
    if (!token) {
      throw new Error("No se puede hacer sesión sin token");
    }
    this.token = token;

    if (isSaveLocalStorage && token) {
      window.localStorage.setItem(this.KEY_LOCALSTORAGE_TOKEN, token);
    }
  }

  registrarUsuario(userData) {
    if (!userData) {
      throw new Error("No se puede hacer sesión sin usuario.");
    }
    this.userData = userData;

    if (userData) {
      const json = JSON.stringify(userData);
      window.localStorage.setItem(this.KEY_LOCALSTORAGE_USERDATA, json);
    }
  }

  getIsAuthenticated() {
    if (this.token === null) {
      return false;
    }
    return true;
  }

  getToken() {
    return this.token;
  }

  getUser() {
    return this.userData;
  }

  setLogOut() {
    this.token = null;
    this.userData = null;
    window.localStorage.removeItem(this.KEY_LOCALSTORAGE_TOKEN);
    window.localStorage.removeItem(this.KEY_LOCALSTORAGE_USERDATA);
  }
}

const authService = new Singleton();

export default authService;
